module.exports = __webpack_public_path__ + "img/bi_software.ded36b9d.svg";